export default __webpack_public_path__ + "images/e89630fcb08a3f2e00dc7417feb01a1b-hobbies.webp";